import { createContext } from 'react'

import { BirdviewScope } from '../DashboardBirdview.constants'

export const BirdviewEffectiveScopeContext = createContext(BirdviewScope.Mine)
